import { StartExercise, UpdateObjective } from "Phaser/EventBus";
import { Event, Exercise, Lecture, NoTimeExercise, PianoScene, Section, StaffExercise, Tutorial } from "Utils/TutorialConfigHelper";
import { AddEventsAndMergeTimestamps, Timestamps } from "Utils/ChaptersToTimestamps";
import timestamps from "./level18.json";

const Level18 = Tutorial(18, '2:06.5', [
  Section([
    Lecture('E in the Bass Clef', '0:0'),
    Lecture('E on the Keyboard', '0:08'),
    Exercise('Find E', '0:21', PianoScene({
      objectives: [
        {
          target: 'E3',
          text: 'Play E on your keyboard'
        }
      ]
    }), [
    ])
  ]),
  Section([
    Lecture('Shifting to E Position', '0:27'),
    Exercise('E Position', '1:11', NoTimeExercise({ centre_align_horizontal: true, objectives: [{}, {}] }), [
    ]),
    Exercise('Playing in Time', '1:23', StaffExercise({ objectives: [{ tempo: 72 }, { tempo: 72 }] }), [
    ]),
  ]),
  Section([
    Lecture('Using Both Hands', '1:34'),
    Exercise('Alternating Hands', '1:44', StaffExercise({ objectives: [{ tempo: 72 }, { tempo: 72 }] }), [
    ]),
    Exercise('Hands Together', '1:58', StaffExercise({ objectives: [{ tempo: 72 }, { tempo: 72 }] }), [
    ]),
  ])
]);

export default AddEventsAndMergeTimestamps(timestamps as Timestamps, Level18);
